/* COMPONENT IMPORTS*/
import ContextConstructor from "../Context/Context";

/* MODULE IMPORTS */

import React, { Component } from "react";

/* SAME FOLDER IMPORTS*/

/* CSS IMPORT */
import "./ProductDetails.css";

class ProductDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      elementID: this.props.elementID,
      productName: this.props.productName,
      productID: this.props.productID,
      subscriptionsNumber: this.props.subscriptionsNumber,
      subscriptionSerie: this.props.subscriptionsSerie,
      subscriptionSerieID: this.props.subscriptionSerieID,
      subscriptionNumber: this.props.subscriptionNumber,
      subscriptionState: this.props.subscriptionState,
      active: this.props.subscriptionActive,
      data: [],
      type: this.props.subscriptionType,
      hasData: false,
      /**startDateBFTeaser: null,
            endDateBFTeaser: null,
            startDateBF: null,
            endDateBF: null,
            actualDate: null,**/
      //actualDateAVOA: null,
      //startDateAVOA: null,
      //endDateAVOA: null,
      //flagAVOA:false
    };
  }

  componentDidMount() {
    //this.GetBlackWeekDates();
    /*this.getAVOApopup();*/
  }

  transformSubscribe = (a) => {
    if (a === 1) return a + " subscrição";
    else return a + " subscrições";
  };

  RenderTitle(state) {
    if (state.type == "serie" && state.subscriptionState == "ATIVA") {
      return (
        <div
          className="serie-name-wrapper"
          style={{ position: "initial !important", cursor: "pointer", display: "inline-block" }}>
          <div className="SavingsItems-value">{state.subscriptionSerie}</div>
          <div className="SavingsItems-number">Nº Inscrição {state.subscriptionNumber}</div>
        </div>
      );
    } else if (state.type == "serie" && !(state.subscriptionState == "ATIVA")) {
      return (
        <div
          className="serie-name-wrapper"
          style={{ position: "initial !important", cursor: "pointer", display: "inline-block" }}>
          <div className="SavingsItems-value" style={{ color: "#B2B2B2" }}>
            {state.subscriptionSerie}
          </div>
          <div className="SavingsItems-number" style={{ color: "#B2B2B2" }}>
            Nº Inscrição {state.subscriptionNumber}
          </div>
        </div>
      );
    } else if (!(state.type == "serie") && state.active) {
      if (typeof state.subscriptionsNumber != "undefined" && state.productName == "PRAZO CERTO") {
        return (
          <div className="serie-name-wrapper" style={{ position: "initial !important" }}>
            <div id={state.elementID} className="tableCapitalCerto-title-inactive">
              {state.productName}
            </div>
          </div>
        );
      } else if (typeof state.subscriptionsNumber != "undefined") {
        return (
          <span className="serie-name-wrapper" style={{ position: "initial !important" }}>
            <div className="tableCapitalCerto-title">{state.productName}</div>
            <div className="tableCapitalCerto-titlesubtitle">
              {this.transformSubscribe(state.subscriptionsNumber)}
            </div>
          </span>
        );
      } else {
        return (
          <div className="serie-name-wrapper" style={{ position: "initial !important" }}>
            <div className="tableCapitalCerto-title">{state.productName}</div>
          </div>
        );
      }
    } else {
      return (
        <div className="serie-name-wrapper" style={{ position: "initial !important" }}>
          <div id={state.elementID} className="tableCapitalCerto-title-inactive">
            {state.productName}
          </div>
        </div>
      );
    }
  }

  renderData(state) {
    let modalityType = this.state.type ? "série" : "modalidade";
    return this.RenderTitle(state);
  }

  render() {
    let contents = this.renderData(this.state);
    return <main>{contents}</main>;
  }
}

ProductDetails.contextType = ContextConstructor;

export default (ProductDetails);
